<h2 class="divider mat-display-3">
  <ng-content></ng-content>
</h2>